import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { openModal, MODAL_TYPES } from '@t7x000/apex-web/lib/redux/actions/modalActions';
import PageHeaderLayout from '../layouts/PageHeaderLayout/PageHeaderLayout';
import withAuthentication from '@t7x000/apex-web/lib/hocs/withAuthentication';

import DashboardPage from './DashboardPage';
import MarketDataPage from './MarketDataPage';
import BuySellPage from './BuySellPage';
// import ConvertPage from '@t7x000/apex-web/lib/layouts/ConvertLayout/ConvertLayout';
// import ProductDetailsPage from './ProductDetailsPage';
import SettingsPage from './SettingsPage';
import { TradingPage as TradingPageContainer } from './Exchange/TradingPage';
import TransactionsPage from './TransactionsPage';

import WalletsLayout from '@t7x000/apex-web/lib/layouts/WalletsLayout/WalletsLayoutContainer';

import DigitalAssetsPage from './DigitalAssets';
import DigitalAssetsOfferingProfilePage from './DigitalAssetsOfferingProfilePage';
import forVerified from '@t7x000/apex-web/lib/hocs/forVerified';

import StreamingPage from './StreamingPage';
import VerificationRequiredBanner from '../components/VerificationRequired/VerificationRequiredContainer';
import { marginBorrowerEnabledSelector } from '@t7x000/apex-web/lib/redux/margin/selectors/marginSelectors';
import { futuresEnabledSelector } from '@t7x000/apex-web/lib/redux/futures/selectors/futuresSelectors';
import ExchangeNavModalContainer from '@t7x000/apex-web/lib/components/ExchangeNavModal/ExchangeNavModalContainer';
import './DigitalAssets.css';
import { UiViewModeProvider } from '../context/UiViewModeContext';

const ExchangeRouteGuard = ({ accountType, redirectTo }) => {
  const dispatch = useDispatch();
  const marginEnabled = useSelector(marginBorrowerEnabledSelector);
  const futuresEnabled = useSelector(futuresEnabledSelector);

  if (redirectTo) {
    return <Redirect to={redirectTo} />;
  }

  if (accountType === 'Margin' && !marginEnabled) {
    dispatch(openModal(MODAL_TYPES.EXCHANGE_NAV_WARNING, { feature: 'Margin' }));
    return <Redirect to="/dashboard" />;
  }

  if (accountType === 'Futures' && !futuresEnabled) {
    dispatch(openModal(MODAL_TYPES.EXCHANGE_NAV_WARNING, { feature: 'Futures' }));
    return <Redirect to="/dashboard" />;
  }

  return <TradingPageContainer />;
};

const exchangeRoutes = [
  { path: '/trade', exact: true, redirectTo: '/trade/spot' },
  { path: '/trade/spot/:symbol?', accountType: 'Asset' },
  // { path: '/trade/margin/:symbol?', accountType: 'Margin' },
  // { path: '/trade/futures/:symbol?', accountType: 'Futures' },
  { path: '/trade/:symbol?', accountType: 'Asset' },
];

const routesConfig = [
  { path: '/dashboard', component: DashboardPage, exact: true },
  { path: '/dashboard/market-data', component: MarketDataPage },
  { path: '/wallets', component: WalletsLayout },
  { path: '/buy-sell', component: BuySellPage },
  { path: '/transactions', component: TransactionsPage },
  // { path: '/convert', component: ConvertPage },
  // { path: '/iba', component: IBALayout },
  // { path: '/activity', component: ProductDetailsPage },
  { path: '/settings', component: SettingsPage },
  // { path: '/asset-activity-details', component: AssetActivityDetailsLayout },
  { path: '/eotc', component: StreamingPage },
  { path: '/digital-assets', component: DigitalAssetsPage, exact: true },
  { path: '/digital-assets/:id', component: DigitalAssetsOfferingProfilePage },
];

const InteriorPage = () => {
  return (
    <UiViewModeProvider>
      <PageHeaderLayout>
        <VerificationRequiredBanner customKYCMessage="Identity verification is pending, please wait for compliance to review." />
        <ExchangeNavModalContainer />
        <Switch>
          {exchangeRoutes.map(({ path, exact, accountType, redirectTo }) => (
            <Route
              key={`${path}-${accountType || 'redirect'}`}
              exact={exact}
              path={path}
              render={(routeProps) => (
                <ExchangeRouteGuard accountType={accountType} redirectTo={redirectTo} {...routeProps} />
              )}
            />
          ))}
          {routesConfig.map((route, index) => {
            return <Route key={index} exact={route.exact} path={route.path} component={route.component} />;
          })}
        </Switch>
      </PageHeaderLayout>
    </UiViewModeProvider>
  );
};

export default withAuthentication(forVerified(InteriorPage));
